import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router";
import { useArgusConnectionContext } from "../../providers/argus-connection-provider";
import { DespleaIcon } from "../icons/desplega-icon";

/**
 * Linear-style "Ask Argus" button outside the main content card.
 * Clicking opens the Argus sidebar. Hidden on `/argus` (full page).
 */
export const AskArgusPrompt = () => {
  const location = useLocation();
  const { setSidebarOpen } = useArgusConnectionContext();

  if (location.pathname.startsWith("/argus")) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: 1,
        paddingTop: 0.25,
        paddingBottom: 0.75,
        flexShrink: 0,
      }}
    >
      <Box
        onClick={() => setSidebarOpen(true)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          paddingX: 1.5,
          paddingY: 0.5,
          borderRadius: "6px",
          cursor: "pointer",
          color: "text.secondary",
          transition: "color 0.15s, background-color 0.15s",
          "&:hover": {
            color: "text.primary",
            backgroundColor: "action.hover",
          },
        }}
      >
        <DespleaIcon sx={{ fontSize: 14 }} />
        <Typography sx={{ fontSize: "13px", fontWeight: 500, userSelect: "none" }}>
          Ask Argus
        </Typography>
      </Box>
    </Box>
  );
};
